const ROYALTY_ACCOUNT_ROUTE = 'royalties'
const ROYALTY_ACCOUNT_TITLE = 'detailsb2b_royalties'
const REDIRECT_ROUTE = '/b2b/home'
const HOME_ROUTE = 'home'
const HOME_TITLE = 'detailsb2b_welcome'
const FixedProperties = {
    ROYALTY_ACCOUNT_ROUTE,
    ROYALTY_ACCOUNT_TITLE,
    REDIRECT_ROUTE,
    HOME_ROUTE,
    HOME_TITLE
}
export { FixedProperties }